"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCardBalancesParamsSchema = exports.getCardBalancesResponseSchema = exports.getCardBalancesParamsSchema = exports.createMemberEnrollmentResponseSchema = exports.createMemberEnrollmentBodySchema = exports.createMemberEnrollmentParamsSchema = exports.MemberProvisioningMarkerSchema = exports.EnrollmentNameSchema = exports.EnrollmentPhoneNumberSchema = exports.MerchantGroupCardSchema = exports.listMemberGroupCardsResponseSchema = exports.removeMerchantGroupMemberResponseSchema = exports.createMerchantGroupMemberAssignmentResponseSchema = exports.updateMerchantGroupResponseSchema = exports.createMerchantGroupResponseSchema = exports.getMerchantGroupResponseSchema = exports.listMerchantGroupsResponseSchema = exports.createMerchantGroupMemberAssignmentBodySchema = exports.createMerchantGroupMemberAssignmentParamsSchema = exports.updateMerchantGroupBodySchema = exports.createMerchantGroupBodySchema = exports.listMemberGroupCardsParamsSchema = exports.removeMerchantGroupMemberParamsSchema = exports.updateMerchantGroupParamsSchema = exports.createMerchantGroupParamsSchema = exports.getMerchantGroupParamsSchema = exports.listMerchantGroupsParamsSchema = exports.MerchantGroupCardAssignmentSchema = exports.MerchantGroupCardEntitySchema = exports.PersonalMemberCardSchema = exports.updatePersonalMemberCardResponseSchema = exports.createPersonalMemberCardResponseSchema = exports.getPersonalMemberCardResponseSchema = exports.updatePersonalMemberCardBodySchema = exports.createPersonalMemberCardBodySchema = exports.updatePersonalMemberCardParamsSchema = exports.createPersonalMemberCardParamsSchema = exports.getPersonalMemberCardParamsSchema = exports.MerchantMemberCardEntitySchema = exports.MemberItemSchema = exports.removeMemberResponseSchema = exports.removeMemberParamsSchema = exports.updateMemberCreditsResponseSchema = exports.updateMemberCreditsBodySchema = exports.getMemberResponseSchema = exports.listMembersResponseSchema = exports.listMembersQuerySchema = exports.updateMemberCreditsParamsSchema = exports.getMemberParamsSchema = exports.listMembersParamsSchema = void 0;
exports.CardBackgroundSchema = exports.removeCardBackgroundResponseSchema = exports.removeCardBackgroundBodySchema = exports.removeCardBackgroundParamsSchema = exports.createCardBackgroundResponseSchema = exports.createCardBackgroundBodySchema = exports.createCardBackgroundParamsSchema = exports.CardBalancesSchema = exports.createCardBalancesResponseSchema = exports.createCardBalancesBodySchema = void 0;
const zod_1 = require("zod");
const max_1 = require("libphonenumber-js/max");
const common_schemas_1 = require("../base/common.schemas");
const membership_schemas_1 = require("../customer/membership.schemas");
const api_schemas_1 = require("../base/api.schemas");
const timestamp_schemas_1 = require("../base/timestamp.schemas");
// ============================================
// MERCHANT MEMBERS SCHEMAS
// ============================================
// Common merchant params schema
const _MerchantParamsSchema = zod_1.z.object({
    merchantId: zod_1.z.coerce.number().int().positive(),
});
// Member params schema (merchantId + userId)
const _MemberParamsSchema = _MerchantParamsSchema.extend({
    userId: common_schemas_1.uuidSchema,
});
// Params schemas for each endpoint
exports.listMembersParamsSchema = _MerchantParamsSchema;
exports.getMemberParamsSchema = _MemberParamsSchema;
exports.updateMemberCreditsParamsSchema = _MemberParamsSchema;
// GET /merchants/:merchantId/members - Query (FR11-13)
exports.listMembersQuerySchema = zod_1.z.object({
    role: membership_schemas_1.MerchantRoleSchema.optional(),
    search: zod_1.z.string().optional(), // Search by name/phone
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(50),
    cursor: zod_1.z.string().optional(),
});
// Internal schema for member item in list
const _MemberItemSchema = zod_1.z.object({
    user_id: common_schemas_1.uuidSchema,
    display_name: zod_1.z.string().nullable(),
    phone_masked: zod_1.z.string(), // +1***1234
    role: membership_schemas_1.MerchantRoleSchema,
    credit_balance: common_schemas_1.moneyAmountSchema,
    points_balance: zod_1.z.number().int().min(0),
    member_since: timestamp_schemas_1.timestampIsoSchema,
});
// GET /merchants/:merchantId/members - Response
exports.listMembersResponseSchema = (0, api_schemas_1.listResponseSchema)(_MemberItemSchema);
// Internal: Points balance breakdown schema
const _PointsBalanceSchema = zod_1.z.object({
    available: zod_1.z.number().int().min(0),
});
// Internal: Financial summary schema for member detail view (FR153)
const _FinancialSummarySchema = zod_1.z.object({
    total_redemptions: zod_1.z.number().int().min(0),
    total_spending: common_schemas_1.moneyAmountSchema,
    credit_balance: common_schemas_1.moneyAmountSchema,
    points_balance: _PointsBalanceSchema,
});
// Internal: Sharing activity schema for member detail view
const _SharingActivitySchema = zod_1.z.object({
    coupons_shared: zod_1.z.number().int().min(0),
    successful_referrals: zod_1.z.number().int().min(0),
    commission_earned: zod_1.z.number().int().min(0), // In points
});
// Internal: Recent activity item schema
const _RecentActivityItemSchema = zod_1.z.object({
    type: zod_1.z.enum(["redemption", "credit_usage", "prepayment"]),
    amount: common_schemas_1.signedMoneyAmountSchema, // In cents (can be negative for usage)
    created_at: timestamp_schemas_1.timestampIsoSchema,
});
// Internal: Analytics schema for member detail view (FR152-153)
const _MemberAnalyticsSchema = zod_1.z.object({
    financial_summary: _FinancialSummarySchema,
    sharing_activity: _SharingActivitySchema,
    recent_activity: zod_1.z.array(_RecentActivityItemSchema).max(5),
});
// GET /merchants/:merchantId/members/:userId - Response (FR12, FR152-153)
// Extends member item with comprehensive analytics
exports.getMemberResponseSchema = (0, api_schemas_1.dataResponseSchema)(_MemberItemSchema.extend({
    // Full analytics for modal (FR152-153)
    analytics: _MemberAnalyticsSchema,
}));
// PATCH /merchants/:merchantId/members/:userId/credits - Body (FR67)
// Manual credit adjustment with reason
exports.updateMemberCreditsBodySchema = zod_1.z.object({
    amount: common_schemas_1.signedMoneyAmountSchema, // Positive to add, negative to subtract
    reason: zod_1.z.string().min(1).max(500),
});
// PATCH /merchants/:merchantId/members/:userId/credits - Response
exports.updateMemberCreditsResponseSchema = (0, api_schemas_1.dataResponseSchema)(zod_1.z.object({
    new_balance: common_schemas_1.moneyAmountSchema,
    adjustment_id: zod_1.z.number().int(),
}));
// ============================================
// REMOVE MEMBER SCHEMAS
// ============================================
// NOTE: inviteMember schemas removed - members join via self-registration (Story 3.6)
// Params schema for remove member (merchantId + userId)
exports.removeMemberParamsSchema = _MemberParamsSchema;
// DELETE /merchants/:merchantId/members/:userId - Response
exports.removeMemberResponseSchema = api_schemas_1.messageResponseSchema;
// Export for reuse
exports.MemberItemSchema = _MemberItemSchema;
// ============================================
// PERSONAL MEMBER CARD SCHEMAS
// ============================================
/**
 * Member IDs are merchant-entered printable ASCII text. Request schemas trim
 * only the outside ASCII spaces; the entity schema describes the persisted value.
 */
const _MemberIdSchema = zod_1.z
    .string()
    .transform((value) => value.replace(/^ +| +$/g, ""))
    .pipe(zod_1.z
    .string()
    .min(1)
    .max(128)
    .regex(/^[\x20-\x7E]+$/));
const _PersonalMemberIdSchema = _MemberIdSchema;
const _GroupNameInputSchema = zod_1.z
    .string()
    .trim()
    .min(1)
    .max(100);
const _PersistedMemberIdSchema = zod_1.z
    .string()
    .min(1)
    .max(128)
    .regex(/^[\x20-\x7E]+$/)
    .refine((value) => value === value.trim());
const _PersistedGroupNameSchema = zod_1.z
    .string()
    .min(1)
    .max(100)
    .refine((value) => value === value.trim());
const _CardKindSchema = zod_1.z.enum(["personal", "group"]);
/** Group-compatible card entity shape. Story 1.1 exposes only personal cards. */
const _MerchantMemberCardBaseSchema = zod_1.z.object({
    card_id: common_schemas_1.uuidSchema,
    merchant_id: zod_1.z.number().int().positive(),
    kind: _CardKindSchema,
    member_id: _PersistedMemberIdSchema,
    owner_user_merchant_id: zod_1.z.number().int().positive().nullable(),
    group_name: zod_1.z.string().min(1).max(100).nullable(),
    revision: zod_1.z.number().int().positive(),
    // Storage key of the card's background image; null when it has none.
    background_blob_key: zod_1.z.string().max(200).nullable().default(null),
    created_at: timestamp_schemas_1.timestampIsoSchema,
    updated_at: timestamp_schemas_1.timestampIsoSchema,
});
exports.MerchantMemberCardEntitySchema = _MerchantMemberCardBaseSchema;
/** API shape: the storage key is replaced by the public image URL derived from it. */
const _MerchantMemberCardApiBaseSchema = _MerchantMemberCardBaseSchema
    .omit({ background_blob_key: true })
    .extend({ background_image_url: zod_1.z.string().url().nullable().default(null) });
const _PersonalCardParamsSchema = _MemberParamsSchema;
const _PersonalCardSchema = _MerchantMemberCardApiBaseSchema.extend({
    kind: zod_1.z.literal("personal"),
    owner_user_merchant_id: zod_1.z.number().int().positive(),
    group_name: zod_1.z.null(),
    user_merchant_id: zod_1.z.number().int().positive(),
});
exports.getPersonalMemberCardParamsSchema = _PersonalCardParamsSchema;
exports.createPersonalMemberCardParamsSchema = _PersonalCardParamsSchema;
exports.updatePersonalMemberCardParamsSchema = _PersonalCardParamsSchema;
exports.createPersonalMemberCardBodySchema = zod_1.z.object({
    member_id: _PersonalMemberIdSchema,
});
exports.updatePersonalMemberCardBodySchema = zod_1.z.object({
    member_id: _PersonalMemberIdSchema,
    expected_revision: zod_1.z.number().int().positive(),
});
exports.getPersonalMemberCardResponseSchema = (0, api_schemas_1.dataResponseSchema)(_PersonalCardSchema.nullable());
exports.createPersonalMemberCardResponseSchema = (0, api_schemas_1.dataResponseSchema)(_PersonalCardSchema);
exports.updatePersonalMemberCardResponseSchema = (0, api_schemas_1.dataResponseSchema)(_PersonalCardSchema);
exports.PersonalMemberCardSchema = _PersonalCardSchema;
const _GroupMemberCardSchema = _MerchantMemberCardApiBaseSchema.extend({
    kind: zod_1.z.literal("group"),
    owner_user_merchant_id: zod_1.z.null(),
    group_name: _PersistedGroupNameSchema,
});
const _MemberCardAssignmentSchema = zod_1.z.object({
    user_merchant_id: zod_1.z.number().int().positive(),
    user_id: common_schemas_1.uuidSchema,
    display_name: zod_1.z.string().nullable(),
    phone_masked: zod_1.z.string(),
    role: membership_schemas_1.MerchantRoleSchema,
    is_active: zod_1.z.boolean(),
    member_since: timestamp_schemas_1.timestampIsoSchema,
});
const _GroupCardListItemSchema = _GroupMemberCardSchema.extend({
    member_count: zod_1.z.number().int().min(0),
});
const _GroupCardDetailSchema = _GroupMemberCardSchema.extend({
    members: zod_1.z.array(_MemberCardAssignmentSchema),
});
exports.MerchantGroupCardEntitySchema = _GroupMemberCardSchema;
exports.MerchantGroupCardAssignmentSchema = _MemberCardAssignmentSchema;
exports.listMerchantGroupsParamsSchema = _MerchantParamsSchema;
exports.getMerchantGroupParamsSchema = _MerchantParamsSchema.extend({
    cardId: common_schemas_1.uuidSchema,
});
exports.createMerchantGroupParamsSchema = _MerchantParamsSchema;
exports.updateMerchantGroupParamsSchema = exports.getMerchantGroupParamsSchema;
exports.removeMerchantGroupMemberParamsSchema = exports.getMerchantGroupParamsSchema.extend({
    userId: common_schemas_1.uuidSchema,
});
exports.listMemberGroupCardsParamsSchema = _MemberParamsSchema;
exports.createMerchantGroupBodySchema = zod_1.z.object({
    group_name: _GroupNameInputSchema,
    member_id: _MemberIdSchema,
});
exports.updateMerchantGroupBodySchema = zod_1.z.object({
    group_name: _GroupNameInputSchema,
    member_id: _MemberIdSchema,
    expected_revision: zod_1.z.number().int().positive(),
});
exports.createMerchantGroupMemberAssignmentParamsSchema = exports.getMerchantGroupParamsSchema;
exports.createMerchantGroupMemberAssignmentBodySchema = zod_1.z.object({
    user_id: common_schemas_1.uuidSchema,
});
exports.listMerchantGroupsResponseSchema = (0, api_schemas_1.listResponseSchema)(_GroupCardListItemSchema);
exports.getMerchantGroupResponseSchema = (0, api_schemas_1.dataResponseSchema)(_GroupCardDetailSchema);
exports.createMerchantGroupResponseSchema = (0, api_schemas_1.dataResponseSchema)(_GroupCardDetailSchema);
exports.updateMerchantGroupResponseSchema = (0, api_schemas_1.dataResponseSchema)(_GroupCardDetailSchema);
exports.createMerchantGroupMemberAssignmentResponseSchema = (0, api_schemas_1.dataResponseSchema)(_GroupCardDetailSchema);
exports.removeMerchantGroupMemberResponseSchema = api_schemas_1.messageResponseSchema;
exports.listMemberGroupCardsResponseSchema = (0, api_schemas_1.listResponseSchema)(_GroupCardListItemSchema);
exports.MerchantGroupCardSchema = _GroupMemberCardSchema;
// ============================================
// MEMBER ENROLLMENT SCHEMAS
// ============================================
/**
 * Enrollment-only Canadian phone parser. The legacy phoneNumberSchema remains
 * the canonical already-E.164 boundary for the existing OTP flow.
 */
exports.EnrollmentPhoneNumberSchema = zod_1.z
    .string()
    .trim()
    .min(1)
    .superRefine((value, context) => {
    try {
        const parsed = (0, max_1.parsePhoneNumberWithError)(value, "CA");
        if (parsed.country !== "CA") {
            context.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: "Canadian phone required",
            });
        }
        if (parsed.ext !== undefined) {
            context.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: "Extensions are not supported",
            });
        }
        if (!parsed.isValid()) {
            context.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: "Invalid Canadian phone",
            });
        }
    }
    catch {
        context.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: "Invalid Canadian phone",
        });
    }
})
    .transform((value) => (0, max_1.parsePhoneNumberWithError)(value, "CA").number);
exports.EnrollmentNameSchema = zod_1.z
    .string()
    .trim()
    .min(1)
    .refine((value) => Array.from(value).length <= 100, "Name must contain at most 100 characters");
exports.MemberProvisioningMarkerSchema = zod_1.z
    .object({
    version: zod_1.z.literal(1),
    merchant_id: zod_1.z.number().int().positive(),
    operation_id: common_schemas_1.uuidSchema,
})
    .strict();
exports.createMemberEnrollmentParamsSchema = _MerchantParamsSchema;
exports.createMemberEnrollmentBodySchema = zod_1.z.object({
    operation_id: common_schemas_1.uuidSchema,
    phone_number: exports.EnrollmentPhoneNumberSchema,
    display_name: exports.EnrollmentNameSchema,
    preferred_language: zod_1.z.enum(["en", "fr", "zh"]),
    enrollment_mode: zod_1.z.enum(["personal", "company", "both"]).default("personal"),
    member_id: _PersonalMemberIdSchema.optional(),
    group_card_id: common_schemas_1.uuidSchema.optional(),
    group_name: _GroupNameInputSchema.optional(),
    group_member_id: _MemberIdSchema.optional(),
}).superRefine((value, context) => {
    const hasExistingGroup = value.group_card_id !== undefined;
    const hasInlineGroup = value.group_name !== undefined || value.group_member_id !== undefined;
    if (value.enrollment_mode === "personal" && value.member_id === undefined) {
        context.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ["member_id"],
            message: "Personal enrollment requires a personal member ID",
        });
    }
    if (value.enrollment_mode === "company" && value.member_id !== undefined) {
        context.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ["member_id"],
            message: "Company enrollment does not accept a personal member ID",
        });
    }
    if (value.enrollment_mode === "both" && value.member_id === undefined) {
        context.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ["member_id"],
            message: "Both enrollment requires a personal member ID",
        });
    }
    const requiresGroup = value.enrollment_mode !== "personal";
    if (requiresGroup && hasExistingGroup === hasInlineGroup) {
        context.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ["group_card_id"],
            message: "Select an existing group or provide a complete new group",
        });
    }
    if (!requiresGroup && (hasExistingGroup || hasInlineGroup)) {
        context.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ["group_card_id"],
            message: "Personal enrollment cannot include a group",
        });
    }
    if (requiresGroup && hasInlineGroup && (value.group_name === undefined || value.group_member_id === undefined)) {
        context.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ["group_name"],
            message: "New group name and member ID are both required",
        });
    }
});
const _MemberEnrollmentResponseSchema = zod_1.z.object({
    operation_id: common_schemas_1.uuidSchema,
    user_id: common_schemas_1.uuidSchema,
    user_merchant_id: zod_1.z.number().int().positive(),
    card: _PersonalCardSchema.nullable(),
    group_card: _GroupMemberCardSchema.nullable().default(null),
});
exports.createMemberEnrollmentResponseSchema = (0, api_schemas_1.dataResponseSchema)(_MemberEnrollmentResponseSchema);
// ============================================
// CARD BALANCE ENTRY SCHEMAS
// ============================================
const _CardBalanceParamsSchema = _MerchantParamsSchema.extend({
    cardId: common_schemas_1.uuidSchema,
});
// Cents column is a 32-bit integer, so requests are capped at its maximum.
const _BalanceCentsSchema = common_schemas_1.moneyAmountSchema.max(2147483647);
const _LatestBalanceSchema = zod_1.z
    .object({
    amount_cents: common_schemas_1.moneyAmountSchema,
    received_at: timestamp_schemas_1.timestampIsoSchema,
})
    .nullable();
const _CardBalancesSchema = zod_1.z.object({
    card_id: common_schemas_1.uuidSchema,
    prepaid: _LatestBalanceSchema,
    bonus: _LatestBalanceSchema,
});
exports.getCardBalancesParamsSchema = _CardBalanceParamsSchema;
exports.getCardBalancesResponseSchema = (0, api_schemas_1.dataResponseSchema)(_CardBalancesSchema);
exports.createCardBalancesParamsSchema = _CardBalanceParamsSchema;
exports.createCardBalancesBodySchema = zod_1.z
    .object({
    operation_id: common_schemas_1.uuidSchema,
    prepaid_cents: _BalanceCentsSchema.optional(),
    bonus_cents: _BalanceCentsSchema.optional(),
})
    .refine((body) => body.prepaid_cents !== undefined || body.bonus_cents !== undefined, { message: "At least one balance is required" });
exports.createCardBalancesResponseSchema = (0, api_schemas_1.dataResponseSchema)(_CardBalancesSchema);
exports.CardBalancesSchema = _CardBalancesSchema;
// ============================================
// CARD BACKGROUND SCHEMAS
// ============================================
const _CardBackgroundSchema = zod_1.z.object({
    card_id: common_schemas_1.uuidSchema,
    revision: zod_1.z.number().int().positive(),
    background_image_url: zod_1.z.string().url().nullable(),
});
exports.createCardBackgroundParamsSchema = _CardBalanceParamsSchema;
exports.createCardBackgroundBodySchema = zod_1.z.object({
    content_type: zod_1.z.enum(["image/jpeg", "image/png", "image/webp"]),
    // Base64 of at most 2 MB of image bytes.
    image_base64: zod_1.z.string().min(1).max(2_800_000),
    expected_revision: zod_1.z.number().int().positive(),
});
exports.createCardBackgroundResponseSchema = (0, api_schemas_1.dataResponseSchema)(_CardBackgroundSchema);
exports.removeCardBackgroundParamsSchema = _CardBalanceParamsSchema;
exports.removeCardBackgroundBodySchema = zod_1.z.object({
    expected_revision: zod_1.z.number().int().positive(),
});
exports.removeCardBackgroundResponseSchema = (0, api_schemas_1.dataResponseSchema)(_CardBackgroundSchema);
exports.CardBackgroundSchema = _CardBackgroundSchema;
